// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1j7nxUIG27rjocu--nL5MT","right":"_1b4kJQqObiPiFGveRZm6tY"};